import { RC_PHONE_POINT, RC_TABLET_POINT } from './breakpoints.constants'

export const onMobile = () => `@media screen and (max-width: ${RC_PHONE_POINT})`

export const onTablet = () => `@media screen and (max-width: ${RC_TABLET_POINT})`

export const onDesktop = () => `@media screen and (min-width: ${RC_TABLET_POINT})`
